var hashFocus = function () {
    /* This function looks for a change in the hash (activation of an in-page link) and sets focus to and 
      highlights the target element. This is necessary because webkit does not set focus as it should. If 
      the hash is empty (the user hit the back button after activating an in-page link) focus is set to body.
      */
    $(window).on('hashchange', function () {

        var hash = "#" + window.location.hash.replace(/^#/, '');

        if (hash.startsWith("#?cludo")) {
            return;
        }

        if (hash != "#") {
            $(hash).attr('tabindex', -1).on('blur focusout', function () {
                $(this).prop('tabindex', false);
            }).trigger('focus');
        }
        else {
            $(".outer-wrapper").attr('tabindex', -1).on('blur focusout', function () {
                $(this).prop('tabindex', false);
            }).trigger('focus');
        }
    });



};

